import { createBrowserRouter, type RouteObject } from 'react-router';
import * as analytics from '@/modules/analytics/routes';
import * as catalog from '@/modules/catalog/routes';
import * as delivery from '@/modules/delivery/routes';
import * as finance from '@/modules/finance/routes';
import * as hr from '@/modules/hr/routes';
import * as identity from '@/modules/identity/routes';
import * as integrations from '@/modules/integrations/routes';
import * as oms from '@/modules/oms/routes';
import * as org from '@/modules/org/routes';
import * as support from '@/modules/support/routes';
import * as system from '@/modules/system/routes';
import * as wms from '@/modules/wms/routes';
import { HomeRedirect, RequirePortal } from './guards';
import { Shell } from './layout/Shell';
import { NotFoundPage } from './pages/misc';
import { page, type ModuleRoutes } from './route-utils';

/**
 * Modullar ro'yxati — yangi blok = `src/modules/<nom>/routes.tsx` + shu yerga bitta qator.
 * Menyu elementi esa `app/nav.tsx` da.
 */
const MODULES: ModuleRoutes[] = [analytics, identity, org, catalog, wms, oms, delivery, finance, hr, support, integrations, system];

const work: RouteObject[] = MODULES.flatMap((m) => m.workRoutes);
const seller: RouteObject[] = MODULES.flatMap((m) => m.sellerRoutes);

export const router = createBrowserRouter([
  { path: '/login', ...page(() => import('./pages/LoginPage')) },
  { path: '/', element: <HomeRedirect /> },
  {
    path: '/w',
    element: (
      <RequirePortal portal="work">
        <Shell portal="work" />
      </RequirePortal>
    ),
    children: [...work, { path: '*', element: <NotFoundPage /> }],
  },
  {
    path: '/s',
    element: (
      <RequirePortal portal="seller">
        <Shell portal="seller" />
      </RequirePortal>
    ),
    children: [...seller, { path: '*', element: <NotFoundPage /> }],
  },
  { path: '*', element: <NotFoundPage /> },
]);
